import { ReactNode } from "react";
import "./Modal.css";
import "./DialogModal.css";

/**
 * Function component to view dialog modals
 */
export const DialogModalWithForm: React.FC<{
  children: ReactNode;
  width?: string;
  className?: string;
  onSubmit?: () => void;
  onCloseClick: () => void;
}> & {
  Header: React.FC<{ children: string }>;
  SubHeader: React.FC<{ children: string }>;
  Body: React.FC<{ children: ReactNode }>;
  Footer: React.FC<{ children: ReactNode }>;
} = ({ children, width, className, onSubmit, onCloseClick }) => {
  return (
    <DialogModal onCloseClick={onCloseClick} width={width}>
      <form // for automatic input fields verification
        className={className}
        onSubmit={(e) => {
          e.preventDefault();
          if (onSubmit !== undefined) onSubmit();
        }}
      >
        {children}
      </form>
    </DialogModal>
  );
};

/**
 * Function component to view dialog modals
 */
export const DialogModal: React.FC<{
  children: ReactNode;
  width?: string;
  onCloseClick: () => void;
}> & {
  Header: React.FC<{ children: string }>;
  SubHeader: React.FC<{ children: string }>;
  Body: React.FC<{ children: ReactNode }>;
  Footer: React.FC<{ children: ReactNode }>;
} = ({ children, width = "410px", onCloseClick }) => {
  return (
    <>
      <div className="modal modal--dialog">
        <div className="modal--backdrop black" onClick={onCloseClick} />
        <div
          className="modal--fill"
          style={{ width: width }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button type="button" className="dialog-close" aria-label="Закрыть" onClick={onCloseClick}>
            <span aria-hidden="true">×</span>
          </button>
          {children}
        </div>
      </div>
    </>
  );
};

const DialogModalHeader: React.FC<{ children: string }> = (props: {
  children: string;
}) => {
  return <div className="modal--header">{props.children}</div>;
};

const DialogModalSubHeader: React.FC<{ children: string }> = (props: {
  children: string;
}) => {
  return (
    <div className="modal--header" style={{ paddingTop: 0 }}>
      {props.children}
    </div>
  );
};

const DialogModalBody: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="modal--body">{children}</div>;
};

const DialogModalFooter: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="modal--footer">{children}</div>;
};

DialogModalWithForm.Header = DialogModalHeader;
DialogModalWithForm.SubHeader = DialogModalSubHeader;
DialogModalWithForm.Body = DialogModalBody;
DialogModalWithForm.Footer = DialogModalFooter;

DialogModal.Header = DialogModalHeader;
DialogModal.SubHeader = DialogModalSubHeader;
DialogModal.Body = DialogModalBody;
DialogModal.Footer = DialogModalFooter;
